<div class="section position-relative">
    <div class="section-top">
        <h3 class="section-title">Configurări</h3>
        <div class="section-top-actions">
            <button type="button" class="btn btn-sm btn-info pull-right ms-1" (click)="rerenderDT(false)">
                <i class="fa-solid fa-arrows-rotate"></i>
            </button>
            <button *ngIf="permissionsService.hasPermission('indoc-module.administrative.configurations.add')"
                type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
                <i class="fa-solid fa-plus"></i>
                Adaugă
            </button>
        </div>
    </div>

    <div class="table-container">
        <table id="datatable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover  w-100">
        </table>
    </div>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>